<div class="clr-wrapper avi-dropdown-button">
    <button
        class="avi-dropdown-button__dropdown-toggle sel-avi-dropdown-toggle btn btn-primary {{ buttonClassName }}"
        [disabled]="disabled"
        type="button"
        avi-tooltip
        [showOnClick]="true"
        [tooltipControl$]="dropdownButtonControl$"
        [positionsPriority]="positionsPriority"
    >
        <ng-content></ng-content>
        <cds-icon
            class="avi-dropdown-button__caret-icon"
            *ngIf="!hideCaret"
            shape="angle"
            direction="down"
        ></cds-icon>
        <ng-template #aviTooltipContent>
            <avi-dropdown-button-list
                [actions]="actions"
                [context]="context"
                [actionClassName]="actionClassName"
                (onHideDropdown)="hideDropdown()"
                [disabled]="disabled"
            ></avi-dropdown-button-list>
        </ng-template>
    </button>
</div>
